import { COUNTRY_OPTIONS, formatPhone, parsePhoneInput } from "@/lib/phone";

export interface PhoneInputValue {
  countryCode: string;
  whatsapp: string;
}

interface PhoneInputProps {
  countryCode: string;
  whatsapp: string;
  onChange: (next: PhoneInputValue) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

// Campo de telefone padrão do projeto: seletor de país (EUA +1 / Brasil +55)
// + número com máscara. Detecta colagem com "+1"/"+55" e ajusta o seletor sozinho.
export default function PhoneInput({
  countryCode,
  whatsapp,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  className = "",
}: PhoneInputProps) {
  const current = COUNTRY_OPTIONS.find((c) => c.code === countryCode) || COUNTRY_OPTIONS[0];

  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const code = e.target.value;
    const digits = whatsapp.replace(/\D/g, "");
    onChange({ countryCode: code, whatsapp: formatPhone(digits, code) });
  };

  const handleWhatsappChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { countryCode: detected, digits } = parsePhoneInput(e.target.value, countryCode);
    onChange({ countryCode: detected, whatsapp: formatPhone(digits, detected) });
  };

  return (
    <div className={`flex gap-2 min-w-0 ${className}`}>
      <select
        value={countryCode}
        onChange={handleCountryChange}
        disabled={disabled}
        className="shrink-0 w-[88px] px-2 py-3 rounded-lg border border-nude bg-beige/50 font-body text-sm text-brown focus:outline-none focus:border-primary transition-colors cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
        aria-label="Código do país"
      >
        {COUNTRY_OPTIONS.map((c) => (
          <option key={c.code} value={c.code}>
            {c.flag} {c.code}
          </option>
        ))}
      </select>
      <input
        type="tel"
        value={whatsapp}
        onChange={handleWhatsappChange}
        placeholder={placeholder || current.placeholder}
        required={required}
        disabled={disabled}
        inputMode="tel"
        className="min-w-0 flex-1 px-4 py-3 rounded-lg border border-nude bg-beige/50 font-body text-sm text-brown placeholder-brown/40 focus:outline-none focus:border-primary transition-colors disabled:opacity-60"
      />
    </div>
  );
}